import { render, staticRenderFns } from "./emailImageElementEditor.vue?vue&type=template&id=70c888ca&scoped=true&"
import script from "./emailImageElementEditor.vue?vue&type=script&lang=js&"
export * from "./emailImageElementEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c888ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
